import { OrganizationInfo } from '@/components'
export const HostCard = ({ hostInfo, organization }) => {
  return (
    hostInfo && (
      <>
        <div className="ant-statistic-title" style={{ marginTop: '20px' }}>
          Your host
        </div>
        <div className="attendee-card-confirm">
          <OrganizationInfo
            user={hostInfo}
            organization={organization}
            showMessage={true}
            imageSize={80}
            showSocialIcons={false}
          />
        </div>
      </>
    )
  )
}
